export default class appLoader {
    constructor(vue) {
        this.vue = vue
    }
    loadApp() {
        const sid = this.vue.$store.state.user.sid
        const batchData = [
            { url: `/v1/schools/${sid}`, commit: 'setSchool' },
            { url: `/v1/kids`, commit: 'setKids' },
            { url: `/v1/groups?view=true`, commit: 'setGroups' },
            { url: `/v1/parents`, commit: 'setParents' },
            { url: `/v1/storage`, commit: 'setRoleStorage' }
        ]
        return this.vue.$api
            .post(
                `batch`,
                batchData.map(d => d.url)
            )
            .then(({ data }) => {
                this.setStore(data, batchData)
            })
            .then(() => {
                return this.vue.$apiService.getFreeDays()
            })
    }
    setStore(response, batchData) {
        batchData.forEach(data => {
            if (data.commit) {
                this.vue.$store.commit(data.commit, response[data.url])
            }
            if (data.dispatch) {
                this.vue.$store.dispatch(data.dispatch, response[data.url])
            }
        })
    }
}
